import React, { useState, useRef, useEffect } from 'react';
import { useAdmin } from '../../contexts/AdminContext';

export default function EditableText({ value, onSave, tag: Tag = 'span', className = '', multiline = false, placeholder = 'Click to edit...' }) {
  const { isAdmin } = useAdmin();
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);
  const inputRef = useRef(null);

  useEffect(() => { setDraft(value); }, [value]);

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
      if (multiline) {
        inputRef.current.style.height = 'auto';
        inputRef.current.style.height = inputRef.current.scrollHeight + 'px';
      }
    }
  }, [editing, multiline]);

  if (!isAdmin) {
    return <Tag className={className}>{value}</Tag>;
  }

  if (editing) {
    const handleSave = () => {
      if (draft !== value) onSave(draft);
      setEditing(false);
    };
    const handleCancel = () => { setDraft(value); setEditing(false); };
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') handleCancel();
      if (e.key === 'Enter' && !multiline) { e.preventDefault(); handleSave(); }
    };

    if (multiline) {
      return (
        <textarea
          ref={inputRef}
          className={`admin-edit-input admin-edit-textarea ${className}`}
          value={draft}
          onChange={(e) => {
            setDraft(e.target.value);
            e.target.style.height = 'auto';
            e.target.style.height = e.target.scrollHeight + 'px';
          }}
          onBlur={handleSave}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
        />
      );
    }

    return (
      <input
        ref={inputRef}
        type="text"
        className={`admin-edit-input ${className}`}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={handleSave}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
      />
    );
  }

  return (
    <Tag
      className={`${className} admin-editable`}
      onClick={() => setEditing(true)}
      title="Click to edit"
    >
      {value || <span className="admin-placeholder">{placeholder}</span>}
    </Tag>
  );
}